import React, { useState, useEffect, useContext, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useParams, useNavigate } from 'react-router-dom';
import add from '../../assest/images/add.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Icon5 from '../../assest/images/Icon5.png';
import CustomDropdown from '../common/CustomDropdown';
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import { BsPersonBadge } from "react-icons/bs";
import { Modal } from 'react-bootstrap';
import { AiOutlineInfoCircle } from "react-icons/ai";
import PhoneInput from 'react-phone-input-2';
import { MdPlaylistAdd } from "react-icons/md";
import CustomSingleValue from '../common/CustomSingleValue';

const ShipmentEdit = () => {
    const { handleSubmit, register, reset } = useForm();
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    const navigate = useNavigate();
    const { shipmentCode } = useParams();
    const [isSubmitting, setIsSubmitting] = useState(false);
    // State for dropdown selections and loading
    const [logisticParty, setLogisticParty] = useState(null);
    const [vehicleNumber, setVehicleNumber] = useState(null);
    const [routingLocation, setRoutingLocation] = useState(null);
    const [logisticPartyOptions, setLogisticPartyOptions] = useState([]);
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [routingNames, setRoutingNames] = useState([]);
    const [scpNames, setScpNames] = useState([]);
    const [orderNumbers, setOrderNumbers] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [selectedScpNameForOrder, setSelectedScpNameForOrder] = useState(null);
    const [selectedScpIdForOrder, setSelectedScpIdForOrder] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedShipmentType, setSelectedShipmentType] = useState('');
    const [logisticPartyEmpty, setLogisticPartyEmpty] = useState(false);
    const [vehicleNumberEmpty, setVehicleNumberEmpty] = useState(false);
    const [scanningModeEmpty, setScanningModeEmpty] = useState(false);
    const [routenameempty, setRoutenameempty] = useState(false);
    const [enumtype, setEnumtype] = useState('');
    const [scpnameempty, setScpnameempty] = useState(false);
    const [ordernoempty, setOrdernoempty] = useState(false);
    const [initialTableData, setInitialTableData] = useState([]);
    const [comment, setComment] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalSelectedDate, setModalSelectedDate] = useState(selectedDate);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showconfimationModal, setshowconfimationModal] = useState(false);
    const [rowIndexToRemove, setRowIndexToRemove] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isSelectOpen, setIsSelectOpen] = useState(null);
    const [contextReady, setContextReady] = useState(false);
    const [initialShipmentDetails, setInitialShipmentDetails] = useState({});
    const [pendingDriverName, setPendingDriverName] = useState('');
    const [pendingDriverContact, setPendingDriverContact] = useState('');
    const scanningModeOptions = [
        { id: '1', label: 'Vendor' },
        { id: '2', label: 'Product' }
    ];
    const [isScanningModeDisabled, setIsScanningModeDisabled] = useState(false);
    const [showDriverModal, setShowDriverModal] = useState(false);
    const [driverName, setDriverName] = useState("");
    const [driverContact, setDriverContact] = useState("");
    const [driverErrors, setDriverErrors] = useState({
        name: false,
        contact: false,
        message: ''
    });
    const toastRef = useRef(null);
    const showToast = (type, message, options = {}) => {
        if (toastRef.current && toast.isActive(toastRef.current)) {
            toast.update(toastRef.current, {
                render: message,
                type,
                autoClose: 3000,
                ...options,
            });
        } else {
            toastRef.current = toast[type](message, {
                autoClose: 3000,
                ...options,
            });
        }
    };

    const phoneNumberToCountryCode = (dialCode) => {
        dialCode = String(dialCode); // 👈 Fix here
        switch (dialCode) {
            case '91': return 'in';
            case '1': return 'us';
            case '93': return 'af';
            case '213': return 'dz';
            case '61': return 'au';
            case '43': return 'at';
            case '32': return 'be';
            default: return undefined;
        }
    };
    const [phoneNumberCountry, setPhoneNumberCountry] = useState('91');
    const prevCountryRef = useRef(phoneNumberCountry || "91");
    const [resetCounter, setResetCounter] = useState(0);
    const allowedCountries = ['in', 'us', 'af', 'dz', 'au', 'at', 'be'];
    const phoneLengthMapping = {
        "91": 10, // India
        "1": 10,  // USA / Canada
        "44": 10, // UK
        "971": 9, // UAE
        "966": 9, // Saudi
        "61": 9,  // Australia
    };

    const fetchScanningMode = async () => {
        try {
            const response = await fetch(
                `${config.API_URL}/api/scanningmode/${selectedScpId}/${UM_CompanyID}`
            );

            if (!response.ok) {
                throw new Error(`Failed to fetch scanning mode for SCP ID: ${selectedScpId}`);
            }

            const data = await response.json();

            console.log("data.allowedScanningMode", data.allowedScanningMode)
            // ✅ Disable logic
            if (data.allowedScanningMode === 2 || data.allowedScanningMode === 3) {
                setIsScanningModeDisabled(true);
            } else {
                setIsScanningModeDisabled(false);
            }

        } catch (error) {
            console.error('Error fetching scanning mode:', error);
        }
    };

    useEffect(() => {
        fetchScanningMode();
    }, []);


    // Check if context is ready
    useEffect(() => {
        if (UM_CompanyID && selectedScpId && shipmentCode) {
            console.log('Context ready:', { UM_CompanyID, selectedScpId, shipmentCode });
            setContextReady(true);
        } else {
            console.error('Context not ready:', { UM_CompanyID, selectedScpId, shipmentCode });
            setIsLoading(false);
        }
    }, [UM_CompanyID, selectedScpId, shipmentCode]);

    // Store context values in sessionStorage
    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId || '');
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID || '');
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId || '');
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID || '');
        sessionStorage.setItem('UM_UserId', UM_UserId || '');
        sessionStorage.setItem('UM_UserCode', UM_UserCode || '');
        sessionStorage.setItem('selectedScpId', selectedScpId || '');
        console.log('Stored context values in sessionStorage:', {
            UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId
        });
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

    // Fetch with retry mechanism
    const fetchWithRetry = async (url, options = {}, retries = 3, delay = 100) => {
        for (let i = 0; i < retries; i++) {
            try {
                const response = await fetch(url, options);
                if (response.ok) return response;
                const errorText = await response.text();
                throw new Error(`Status: ${response.status}, ${errorText}`);
            } catch (error) {
                console.error(`Attempt ${i + 1} failed for ${url}:`, error.message);
                if (i < retries - 1) {
                    console.log(`Retrying in ${delay}ms...`);
                    await new Promise(resolve => setTimeout(resolve, delay));
                } else {
                    throw error;
                }
            }
        }
    };

    // Fetch initial data and shipment details
    useEffect(() => {
        const fetchInitialData = async () => {
            if (!contextReady) {
                console.error('fetchInitialData: Context not ready, skipping fetch');
                return;
            }

            setIsLoading(true);
            try {
                // Fetch logistic companies
                console.log(`Fetching logistic companies for SCP ID: ${selectedScpId}`);
                const logisticResponse = await fetchWithRetry(`${config.API_URL}/shipment/logisticcompany/${selectedScpId}`);
                const logisticData = await logisticResponse.json();
                console.log('Logistic companies data:', logisticData);
                const logisticOptions = logisticData.logisticCompany && Array.isArray(logisticData.logisticCompany)
                    ? logisticData.logisticCompany.map(option => ({
                        value: option.LGCM_ID,
                        label: option.LGCM_Name || 'Unnamed Company',
                    }))
                    : [];
                setLogisticPartyOptions(logisticOptions);
                if (logisticOptions.length === 0) {
                    //toast.warn('No logistic companies available for the selected SCP.');
                }

                // Fetch routing names
                console.log(`Fetching routing names for Company ID: ${UM_CompanyID}, SCP ID: ${selectedScpId}`);
                const routingResponse = await fetchWithRetry(`${config.API_URL}/shipment/routingname/${UM_CompanyID}/${selectedScpId}`);
                const routingData = await routingResponse.json();
                console.log('Routing names data:', routingData);
                const routingOptions = routingData.routingname && Array.isArray(routingData.routingname)
                    ? routingData.routingname.map(route => ({
                        value: route.RUTL_ID,
                        label: route.RUTL_Name || 'Unnamed Route',
                    }))
                    : [];
                setRoutingNames(routingOptions);
                if (routingOptions.length === 0) {
                    //toast.warn('No routing names available.');
                }

                // Fetch shipment details
                console.log(`Fetching shipment details for shipment code: ${shipmentCode}`);
                const shipmentResponse = await fetchWithRetry(`${config.API_URL}/api/shipmentupdate/${shipmentCode}`);
                const shipmentData = await shipmentResponse.json();
                console.log('Shipment details data:', shipmentData);

                // Store initial shipment details for old values
                setInitialShipmentDetails(shipmentData.shipmentDetails);

                const convertDate = (dateString) => {
                    if (!dateString) return new Date();
                    const [day, month, year] = dateString.split('/');
                    return new Date(`${year}/${month}/${day}`);
                };

                // Set logistic party
                if (shipmentData.shipmentDetails.SHPH_LogisticPartyID) {
                    const matchedLogistic = logisticOptions.find(
                        option => option.value === shipmentData.shipmentDetails.SHPH_LogisticPartyID
                    );
                    if (matchedLogistic) {
                        setLogisticParty(matchedLogistic);
                        console.log('Set logisticParty:', matchedLogistic);
                        // Fetch vehicles
                        console.log(`Fetching vehicles for logistic party ID: ${matchedLogistic.value}`);
                        const vehicleResponse = await fetchWithRetry(`${config.API_URL}/logisticcompany/vehicles/${matchedLogistic.value}`);
                        const vehicleData = await vehicleResponse.json();
                        console.log('Vehicle numbers data:', vehicleData);
                        const vehicleOptions = vehicleData.vehicleData.map(vehicle => ({
                            value: vehicle.LGCVM_ID,
                            label: vehicle.LGCVM_VehicleNumber || 'Unnamed Vehicle',
                            dimension: vehicle.LGCVM_Dimension,
                        }));

                        setVehicleNumbers(vehicleOptions);

                        if (vehicleOptions.length === 0) {
                            //toast.warn('No vehicles available for the selected logistic party.');
                        }
                        // Set vehicle number
                        if (shipmentData.shipmentDetails.SHPH_LogisticVehicleID) {
                            const matchedVehicle = vehicleOptions.find(
                                v => v.value === shipmentData.shipmentDetails.SHPH_LogisticVehicleID
                            );

                            if (matchedVehicle) {
                                setVehicleNumber(matchedVehicle);
                            }

                        }
                    }
                }

                // Set routing location
                if (shipmentData.shipmentDetails.SHPH_SCPRouteID) {
                    const matchedRouting = routingOptions.find(
                        option => option.value === shipmentData.shipmentDetails.SHPH_SCPRouteID
                    );
                    if (matchedRouting) {
                        setRoutingLocation(matchedRouting);
                        console.log('Set routingLocation:', matchedRouting);
                        // Fetch SCP names
                        console.log(`Fetching SCP names for routing ID: ${matchedRouting.value}`);
                        const scpResponse = await fetchWithRetry(`${config.API_URL}/routemaster/scpname/${matchedRouting.value}`);
                        const scpData = await scpResponse.json();
                        console.log('SCP names data:', scpData);
                        const scpOptions = scpData.scpNames && Array.isArray(scpData.scpNames)
                            ? scpData.scpNames.map(scp => ({
                                value: scp.id,
                                label: scp.name || 'Unnamed SCP',
                            }))
                            : [];
                        setScpNames(scpOptions);
                        if (scpOptions.length === 0) {
                            //toast.warn('No SCP names available for the selected route.');
                        }
                    }
                }

                // Set other fields
                setSelectedDate(convertDate(shipmentData.shipmentDetails.SHPH_ShipmentDate));
                setPendingDriverName(shipmentData.shipmentDetails.SHPH_DriverName);
                setPendingDriverContact(shipmentData.shipmentDetails.SHPH_DriverContactNo);
                setDriverName(shipmentData.shipmentDetails.SHPH_DriverName);
                setDriverContact(shipmentData.shipmentDetails.SHPH_DriverContactNo);

                console.log('Set selectedDate:', shipmentData.shipmentDetails.SHPH_ShipmentDate);

                const scanMode = String(shipmentData.shipmentDetails.SHPH_ByProductVendorScanMode);
                const matchedOption = scanningModeOptions.find(
                    option => option.id === scanMode || option.label.toLowerCase() === scanMode.toLowerCase()
                );
                setSelectedStatus(matchedOption ? matchedOption.id : '');
                console.log('Set selectedStatus:', matchedOption ? matchedOption.id : '');

                setSelectedShipmentType(shipmentData.shipmentDetails.SHPH_ShipmentType);
                console.log('Set selectedShipmentType:', shipmentData.shipmentDetails.SHPH_ShipmentType);

                setEnumtype(shipmentData.shipmentDetails.StatusDescription);
                console.log('Set enumtype:', shipmentData.shipmentDetails.StatusDescription);

                setComment(shipmentData.shipmentDetails.SHPH_Comment || '');
                setDriverName(shipmentData.shipmentDetails.SHPH_DriverName || '');
                setDriverContact(shipmentData.shipmentDetails.SHPH_DriverContactNo || '');
                console.log('Set comment:', shipmentData.shipmentDetails.setDriverName);
            } catch (error) {
                console.error('Error fetching initial data:', error);
                navigate('/dashboard/shipment');
            } finally {
                setIsLoading(false);
            }
        };

        if (contextReady) {
            fetchInitialData();
        }
    }, [contextReady, shipmentCode, UM_CompanyID, selectedScpId, navigate]);

    // Fetch table data
    useEffect(() => {
        const fetchTableData = async () => {
            if (!contextReady || !shipmentCode) {
                console.error('fetchTableData: Context not ready or missing shipmentCode', { contextReady, shipmentCode });
                return;
            }

            try {
                console.log(`Fetching table data for shipment code: ${shipmentCode}`);
                const response = await fetchWithRetry(`${config.API_URL}/api/tableData/${shipmentCode}`);
                const data = await response.json();
                console.log('Table data:', data);
                // Create a deep copy of the table data to ensure initialTableData is immutable
                const updatedData = JSON.parse(JSON.stringify(data.tableData)).map(row => ({
                    ...row,
                    originalShipQty: row.shipQty,
                    originalAvailableQty: row.AvailableQty,
                    originalPendingQty: row.ORDIT_PendingQty,
                    volume: row.PL_ProductVolume
                }));
                setTableData(updatedData);
                setInitialTableData(updatedData);
                console.log('Set tableData and initialTableData:', updatedData);
            } catch (error) {
                console.error('Error fetching table data:', error);
            }
        };

        if (contextReady) {
            fetchTableData();
        }
    }, [contextReady, shipmentCode]);

    // Fetch order numbers
    useEffect(() => {
        const fetchOrderNumbers = async () => {
            if (!selectedScpIdForOrder?.value || !contextReady) {
                console.log('Skipping order numbers fetch: selectedScpIdForOrder or context not ready', { selectedScpIdForOrder, contextReady });
                setOrderNumbers([]);
                return;
            }
            try {
                console.log(`Fetching order numbers for SCP ID: ${selectedScpId}, Company ID: ${UM_CompanyID}, Selected SCP ID: ${selectedScpIdForOrder.value}`);
                const response = await fetchWithRetry(`${config.API_URL}/orderlist/ordernumbers/${selectedScpId}/${UM_CompanyID}/${selectedScpIdForOrder.value}`);
                const data = await response.json();
                console.log('Order numbers data:', data);
                const formattedOptions = data.orders && Array.isArray(data.orders)
                    ? data.orders.map(order => ({
                        value: order.orderNumber,
                        label: order.orderNumber,
                    }))
                    : [];
                setOrderNumbers(formattedOptions);
                console.log('Formatted order numbers options:', formattedOptions);
                if (formattedOptions.length === 0) {
                    //toast.warn('No order numbers available for the selected SCP.');
                }
            } catch (error) {
                console.error('Error fetching order numbers:', error);
                setOrderNumbers([]);
            }
        };

        fetchOrderNumbers();
    }, [selectedScpIdForOrder, UM_CompanyID, selectedScpId, contextReady]);

    const logaction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "Shipment Outward Edit:", action, userCode: UM_UserCode, isError }),
            });
            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
        const auditLogPayload = {
            AUTR_ScreenName: module,
            AUTR_OldValue: oldValue,
            AUTR_NewValue: newValue,
            AUTR_Message: message,
            AUTR_UserID: UM_UserId,
            AUTR_UserName: UM_UserCode,
            AUTR_AuditType: 16,
            AUTR_SCPID: selectedScpId,
            AUTR_CompanyGrpId: UM_CompanyGrpID,
            AUTR_CompanyID: UM_CompanyID,
            AUTR_CreatedBy: UM_UserId,
            insertAuditTransaction: transactionDetails.length > 0,
            transactionDetails
        };

        try {
            const response = await fetch(`${config.API_URL}/audit/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(auditLogPayload),
            });

            if (!response.ok) {
                throw new Error('Failed to log audit');
            }
        } catch (error) {
            console.error('Error logging audit:', error);
        }
    };

    const handleLogisticPartyChange = async (selectedOption) => {
        //logaction("handleLogisticPartyChange(): Started");
        setLogisticParty(selectedOption);
        setLogisticPartyEmpty(false);
        setVehicleNumber('');
        setDriverName('');
        setDriverContact('');
        setPendingDriverName('');
        setPendingDriverContact('');
        try {
            console.log(`Fetching vehicles for logistic party ID: ${selectedOption?.value || ''}`);
            const response = await fetchWithRetry(`${config.API_URL}/logisticcompany/vehicles/${selectedOption?.value || ''}`);
            const data = await response.json();
            console.log('Vehicle numbers data:', data);
            const formattedOptions = data.vehicleData && Array.isArray(data.vehicleData)
                ? data.vehicleData.map(vehicle => ({
                    value: vehicle.LGCVM_ID,
                    label: vehicle.LGCVM_VehicleNumber || 'Unnamed Vehicle',
                    dimension: vehicle.LGCVM_Dimension,
                }))
                : [];
            setVehicleNumbers(formattedOptions);
            setVehicleNumber(null);
            console.log('Formatted vehicle numbers options:', formattedOptions);
            //logaction(`handleLogisticPartyChange(): Data fetched: ${JSON.stringify(data)}`);
            if (formattedOptions.length === 0) {
                //toast.warn('No vehicles available for the selected logistic party.');
            }
        } catch (error) {
            //logaction("handleLogisticPartyChange(): Error fetching vehicle numbers", true);
            console.error('Error fetching vehicle numbers:', error);
            //showToast('error', `Failed to load vehicle numbers: ${error.message}`);
            setVehicleNumbers([]);
        }
    };

    const handleRoutingChange = async (selectedOption) => {
        //logaction("handleRoutingChange(): Started");
        setRoutingLocation(selectedOption);
        setSelectedOrder(null);
        setSelectedScpIdForOrder(null);
        setSelectedScpNameForOrder(null);
        setRoutenameempty(false);
        try {
            console.log(`Fetching SCP names for routing ID: ${selectedOption?.value || ''}`);
            const response = await fetchWithRetry(`${config.API_URL}/routemaster/scpname/${selectedOption?.value || ''}`);
            const data = await response.json();
            console.log('SCP names data:', data);
            const formattedOptions = data.scpNames && Array.isArray(data.scpNames)
                ? data.scpNames.map(scp => ({
                    value: scp.id,
                    label: scp.name || 'Unnamed SCP',
                }))
                : [];
            setScpNames(formattedOptions);
            setSelectedScpIdForOrder(null);
            setSelectedScpNameForOrder(null);
            console.log('Formatted SCP names options:', formattedOptions);
            //logaction(`handleRoutingChange(): Data fetched: ${JSON.stringify(data)}`);
            if (formattedOptions.length === 0) {
                toast.warn('No SCP names available for the selected route.');
            }
        } catch (error) {
            //logaction("handleRoutingChange(): Error fetching SCP names", true);
            console.error('Error fetching SCP names:', error);
            showToast('error', `Failed to load SCP names: ${error.message}`);
            setScpNames([]);
        }
    };

    const getFreedQtyMap = () => {
        const freedMap = {};

        initialTableData.forEach(initRow => {
            const stillExists = tableData.some(
                r =>
                    r.SHPD_ProductCode === initRow.SHPD_ProductCode &&
                    r.ORDM_OrderNumber === initRow.ORDM_OrderNumber
            );

            if (!stillExists) {
                const code = initRow.SHPD_ProductCode;

                if (!freedMap[code]) freedMap[code] = 0;

                freedMap[code] += parseInt(initRow.shipQty) || 0;

                console.log(
                    `Freed ${initRow.shipQty} for product ${code} from removed initial row`
                );
            }
        });

        return freedMap;
    };

    const handleAddAllButtonClick = async () => {

        logaction("handleAddAllButtonClick clicked");

        let isValid = true;

        if (!routingLocation) {
            logaction("Routing location not selected", true);
            setRoutenameempty(true);
            isValid = false;
        } else setRoutenameempty(false);

        if (!selectedScpIdForOrder) {
            logaction("SCP not selected", true);
            setScpnameempty(true);
            isValid = false;
        } else setScpnameempty(false);

        if (!isValid) {
            logaction("Validation failed", true);
            return;
        }

        if (orderNumbers.length === 0) {
            logaction("No order numbers available for selected SCP", true);
            showToast('error', `There are no order numbers available for selected SCP.`);
            return;
        }

        try {

            logaction("Processing Add All orders");

            let lastSerialNumber =
                tableData.length > 0 ? tableData[tableData.length - 1].srNo : 0;

            // ✅ GET FREED QTY
            const freedQtyMap = getFreedQtyMap();

            const runningAvailableMap = {};

            // preload from existing table
            tableData.forEach(row => {
                const code = row.SHPD_ProductCode;

                if (!runningAvailableMap[code]) {
                    runningAvailableMap[code] = row.originalAvailableQty;
                }

                runningAvailableMap[code] -= (parseInt(row.shipQty) || 0);

                // ✅ ADD FREED QTY BACK
                runningAvailableMap[code] += (freedQtyMap[code] || 0);
            });

            logaction("Fetching order details for all orders");

            const allOrderDetails = await Promise.all(
                orderNumbers.map(async (order) => {

                    const orderNumber = order.value;

                    const response = await fetchWithRetry(
                        `${config.API_URL}/orderdetails/${orderNumber}/${selectedScpId}`
                    );

                    const responseData = await response.json();

                    return responseData.orderDetails
                        .filter(d => d.ORDIT_PendingQty !== 0)
                        .map(orderDetail => {

                            const exists = tableData.some(
                                row =>
                                    row.ORDM_OrderNumber === orderNumber &&
                                    row.SHPD_ProductCode === orderDetail.PL_ProductCode
                            );

                            if (exists) return null;

                            const code = orderDetail.PL_ProductCode;

                            const originalAvailable =
                                Math.max(0, parseInt(orderDetail.totalPackSize) || 0);

                            if (runningAvailableMap[code] === undefined) {
                                runningAvailableMap[code] =
                                    originalAvailable + (freedQtyMap[code] || 0);
                            }

                            const remainingAvailable =
                                Math.max(0, runningAvailableMap[code]);

                            const autoShipQty = Math.min(
                                orderDetail.ORDIT_PendingQty,
                                remainingAvailable
                            );

                            runningAvailableMap[code] -= autoShipQty;

                            lastSerialNumber++;

                            return {
                                srNo: lastSerialNumber,

                                scpId: selectedScpIdForOrder.value,
                                SCPM_Name: selectedScpNameForOrder.label,

                                ORDM_OrderNumber: orderNumber,

                                SHPD_ProductName: orderDetail.PL_ProductName,
                                SHPD_ProductCode: code,

                                originalAvailableQty: originalAvailable,
                                AvailableQty: runningAvailableMap[code],

                                SHPD_OrderQty: orderDetail.ORDIT_OrderQTY,

                                originalPendingQty: orderDetail.ORDIT_PendingQty,
                                ORDIT_PendingQty:
                                    orderDetail.ORDIT_PendingQty - autoShipQty,

                                shipQty: autoShipQty,
                                orderedQty: orderDetail.ORDIT_OrderQTY,

                                originalShipQty: autoShipQty,
                                volume: orderDetail.Volume,
                            };

                        })
                        .filter(Boolean);
                })
            );

            const flattened = allOrderDetails.flat();

            if (flattened.length === 0) {
                showToast('error', 'All Orders are already added for this SCP.');
                return;
            }

            // ✅ GLOBAL RECALC (same as Add button)

            const shippedMap = {};

            [...tableData, ...flattened].forEach(row => {
                const code = row.SHPD_ProductCode;
                if (!shippedMap[code]) shippedMap[code] = 0;
                shippedMap[code] += parseInt(row.shipQty) || 0;
            });

            const runningAvailableMapFinal = {};

            [...tableData, ...flattened].forEach(row => {
                const code = row.SHPD_ProductCode;

                const original = parseInt(row.originalAvailableQty) || 0;
                const shipped = shippedMap[code] || 0;
                const freed = freedQtyMap[code] || 0;

                runningAvailableMapFinal[code] =
                    Math.max(0, original - shipped + freed);
            });

            const updatedExisting = tableData.map(row => ({
                ...row,
                AvailableQty: Math.max(
                    0,
                    runningAvailableMapFinal[row.SHPD_ProductCode]
                )
            }));

            const updatedNew = flattened.map(row => ({
                ...row,
                AvailableQty: Math.max(
                    0,
                    runningAvailableMapFinal[row.SHPD_ProductCode]
                )
            }));

            setTableData([...updatedExisting, ...updatedNew]);

            logaction(`Added ${flattened.length} rows to table`);

        } catch (error) {
            console.error(error);
            showToast('error', `Failed to add orders: ${error.message}`);
        }
    };


    const handleAddButtonClick = async () => {

        logaction("handleAddButtonClick clicked");

        let isValid = true;

        if (!routingLocation) {
            logaction("Routing location not selected", true);
            setRoutenameempty(true);
            isValid = false;
        } else setRoutenameempty(false);

        if (!selectedScpIdForOrder) {
            logaction("SCP not selected", true);
            setScpnameempty(true);
            isValid = false;
        } else setScpnameempty(false);

        if (!selectedOrder) {
            logaction("Order not selected", true);
            setOrdernoempty(true);
            isValid = false;
        } else setOrdernoempty(false);

        if (!isValid) {
            logaction("Validation failed", true);
            return;
        }

        const selectedOrderNumber = selectedOrder.value;

        try {

            logaction(`Fetching order details for ${selectedOrderNumber}`);

            const response = await fetchWithRetry(
                `${config.API_URL}/orderdetails/${selectedOrderNumber}/${selectedScpId}`
            );

            const responseData = await response.json();

            const filteredOrderDetails =
                responseData.orderDetails.filter(
                    d => d.ORDIT_PendingQty !== 0
                );

            let allExistInTable = true;

            const newTableRows = filteredOrderDetails.map((orderDetail, index) => {

                const exists = tableData.some(
                    row =>
                        row.ORDM_OrderNumber === selectedOrderNumber &&
                        row.SHPD_ProductCode === orderDetail.PL_ProductCode
                );

                if (exists) {
                    logaction(`Product ${orderDetail.PL_ProductCode} already exists for order ${selectedOrderNumber}`);
                    return null;
                }

                allExistInTable = false;

                const code = orderDetail.PL_ProductCode;

                // const alreadyShipped = tableData
                //     .filter(r => r.SHPD_ProductCode === code)
                //     .reduce((sum, r) => sum + (parseInt(r.shipQty) || 0), 0);

                // const originalAvailable = Math.max(
                //     0,
                //     parseInt(orderDetail.totalPackSize) || 0
                // );

                const freedQtyMap = getFreedQtyMap();

                const alreadyShipped = tableData
                    .filter(r => r.SHPD_ProductCode === code)
                    .reduce((sum, r) => sum + (parseInt(r.shipQty) || 0), 0);

                const originalAvailable =
                    Math.max(0, parseInt(orderDetail.totalPackSize) || 0);

                const freedQty = freedQtyMap[code] || 0;

                const remainingAvailable =
                    originalAvailable - alreadyShipped + freedQty;

                console.log("Remaining calc:", {
                    code,
                    originalAvailable,
                    alreadyShipped,
                    freedQty,
                    remainingAvailable
                });


                const autoShipQty = Math.min(
                    orderDetail.ORDIT_PendingQty,
                    remainingAvailable
                );

                return {
                    srNo: tableData.length + index + 1,

                    scpId: selectedScpIdForOrder.value,
                    SCPM_Name: selectedScpNameForOrder.label,

                    ORDM_OrderNumber: selectedOrderNumber,

                    SHPD_ProductName: orderDetail.PL_ProductName,
                    SHPD_ProductCode: code,

                    originalAvailableQty: originalAvailable,
                    AvailableQty: remainingAvailable - autoShipQty,

                    SHPD_OrderQty: orderDetail.ORDIT_OrderQTY,

                    originalPendingQty: orderDetail.ORDIT_PendingQty,
                    ORDIT_PendingQty:
                        orderDetail.ORDIT_PendingQty - autoShipQty,

                    shipQty: autoShipQty,
                    orderedQty: orderDetail.ORDIT_OrderQTY,

                    originalShipQty: autoShipQty,
                    volume: orderDetail.Volume,
                };

            });

            const validNewRows = newTableRows.filter(Boolean);

            if (validNewRows.length === 0 && allExistInTable) {
                logaction("All selected orders/products already added", true);
                showToast('error', `All selected Orders and Products are already added.`);
                setSelectedOrder("");
                return;
            }

            // ✅ Recalculate stock correctly

            const freedQtyMap = getFreedQtyMap();

            // total shipped per product
            const shippedMap = {};

            [...tableData, ...validNewRows].forEach(row => {
                const code = row.SHPD_ProductCode;

                if (!shippedMap[code]) shippedMap[code] = 0;
                shippedMap[code] += parseInt(row.shipQty) || 0;
            });

            const runningAvailableMapFinal = {};

            [...tableData, ...validNewRows].forEach(row => {
                const code = row.SHPD_ProductCode;

                const original = parseInt(row.originalAvailableQty) || 0;
                const shipped = shippedMap[code] || 0;
                const freed = freedQtyMap[code] || 0;

                runningAvailableMapFinal[code] =
                    Math.max(0, original - shipped + freed);
            });


            // 🔥 Update all rows
            const updatedExisting = tableData.map(row => ({
                ...row,
                AvailableQty: Math.max(
                    0,
                    runningAvailableMapFinal[row.SHPD_ProductCode] ??
                    row.AvailableQty
                )

            }));

            const updatedNew = validNewRows.map(row => ({
                ...row,
                AvailableQty: Math.max(
                    0,
                    runningAvailableMapFinal[row.SHPD_ProductCode] ??
                    row.AvailableQty
                )

            }));

            setTableData([...updatedExisting, ...updatedNew]);

            logaction(`Added ${validNewRows.length} rows to table`);

            setScpnameempty(false);
            setOrdernoempty(false);

        } catch (error) {
            console.error('Error adding table data:', error);
            logaction(`Error adding table data: ${error.message}`, true);
            showToast('error', `Failed to add order: ${error.message}`);
        }
    };



    const calculateShipQtySums = (data) => {
        return data.reduce((acc, row) => {
            if (acc[row.SHPD_ProductCode]) {
                acc[row.SHPD_ProductCode] += row.shipQty;
            } else {
                acc[row.SHPD_ProductCode] = row.shipQty;
            }
            return acc;
        }, {});
    };

    const showConfirmDialog = (index) => {
        setRowIndexToRemove(index);
        setShowConfirmation(true);
    };

    const hideConfirmDialog = () => {
        setRowIndexToRemove(null);
        setShowConfirmation(false);
    };

    const handleConfirmedRemoval = () => {
        handleRemoveButtonClick(rowIndexToRemove);
        hideConfirmDialog();
    };

    const handleRemoveButtonClick = (index) => {
        //logaction(`handleRemoveButtonClick(): Removing row at index ${index}`);
        const updatedTableData = JSON.parse(JSON.stringify(tableData));
        const removedRow = updatedTableData.splice(index, 1)[0];

        const updatedTableDataWithAdjustedQty = updatedTableData.map(row => {
            if (row.SHPD_ProductCode === removedRow.SHPD_ProductCode) {
                return {
                    ...row,
                    AvailableQty: row.AvailableQty + removedRow.shipQty,
                };
            }
            return row;
        });

        const finalTableData = updatedTableDataWithAdjustedQty.map((row, idx) => ({
            ...row,
            srNo: idx + 1,
        }));

        setTableData(finalTableData);
        //logaction("handleRemoveButtonClick(): Row removed and tableData updated");
        console.log('After handleRemoveButtonClick - initialTableData:', initialTableData);
        console.log('After handleRemoveButtonClick - tableData:', finalTableData);
    };

    const validateBeforeConfirm = (data) => {

        let isValid = true;

        if (!logisticParty) {
            logaction("onSubmit(): Logistic party empty", true);
            setLogisticPartyEmpty(true);
            isValid = false;
        } else {
            setLogisticPartyEmpty(false);
        }

        if (!selectedStatus) {
            logaction("onSubmit(): Scanning mode empty", true);
            setScanningModeEmpty(true);
            isValid = false;
        } else {
            setScanningModeEmpty(false);
        }

        if (!isValid) return;

        if (tableData.length <= 0) {
            logaction("onSubmit(): No orders in table", true);
            showToast('error', "At least one order is required to update the shipment.");
            return
        }



        if (vehicleNumber?.value) {
            if (!driverName?.trim() || !driverContact?.trim()) {
                logaction("onSubmit(): Driver details missing", true);
                showToast('error', "Please enter the Driver Details.");
                setShowDriverModal(true);
                return;
            }
        }

        if (canCalculateCapacity && usedVolume > vehicleCapacity) {
            logaction(`onSubmit(): Vehicle capacity exceeded - Used ${rawUsedPercentage.toFixed(2)}%`, true);
            showToast('error',
                `Vehicle capacity exceeded with ${rawUsedPercentage.toFixed(2)}% of its capacity. Please reduce shipment quantity or select a larger vehicle.`
            );
            return;
        }

        for (const item of tableData) {
            if (item.shipQty === '' || item.shipQty === null) {
                logaction(`onSubmit(): Ship quantity empty for product ${item.SHPD_ProductCode}`, true);
                showToast('error',
                    `Please Enter Ship Quantity for Product : ${item.SHPD_ProductName}.`
                );
                isValid = false;
            }
            else if (parseInt(item.shipQty) <= 0) {
                logaction(`onSubmit(): Invalid ship quantity for product ${item.SHPD_ProductCode}`, true);
                showToast('error',
                    `Please Enter Ship Quantity for Product : ${item.SHPD_ProductName}.`
                );
                isValid = false;
            }
        }

        if (!isValid) {
            logaction("onSubmit(): Validation failed after shipQty check", true);
            return;
        }

        if (usedVolume > vehicleCapacity) {
            logaction(`onSubmit(): Vehicle capacity exceeded (final check) - Used ${rawUsedPercentage.toFixed(2)}%`, true);
            showToast('error',
                `Vehicle capacity exceeded with ${rawUsedPercentage.toFixed(2)}% of its capacity. Please reduce shipment quantity or select a larger vehicle.`
            );
            return;
        }

        // ✅ ONLY CHANGE → show confirmation
        setshowconfimationModal(true);
    };


    const onSubmit = async (data) => {
        logaction("onSubmit(): Started");
        //logaction("onSubmit(): Started");
        if (isSubmitting) {
            logaction("onSubmit(): Already submitting - blocked", true);
            return;
        }

        setIsSubmitting(true);
        let isValid = true;

        if (!logisticParty) {
            logaction("onSubmit(): Logistic party empty", true);
            setLogisticPartyEmpty(true);
            isValid = false;
        } else {
            setLogisticPartyEmpty(false);
        }

        if (!selectedStatus) {
            logaction("onSubmit(): Scanning mode empty", true);
            setScanningModeEmpty(true);
            isValid = false;
        } else {
            setScanningModeEmpty(false);
        }

        if (tableData.length <= 0) {
            logaction("onSubmit(): No orders in table", true);
            showToast('error', "At least one order is required to update the shipment.");
            isValid = false;
        }

        if (!isValid) {
            logaction("onSubmit(): Validation failed", true);
            setIsSubmitting(false);
            return
        }

        if (vehicleNumber?.value) {
            if (!driverName?.trim() || !driverContact?.trim()) {
                logaction("onSubmit(): Driver details missing", true);
                showToast('error', "Please enter the Driver Details.");
                setShowDriverModal(true);
                setIsSubmitting(false);
                return;
            }
        }

        if (canCalculateCapacity && usedVolume > vehicleCapacity) {
            logaction(`onSubmit(): Vehicle capacity exceeded - Used ${rawUsedPercentage.toFixed(2)}%`, true);
            showToast('error',
                `Vehicle capacity exceeded with ${rawUsedPercentage.toFixed(2)}% of its capacity. Please reduce shipment quantity or select a larger vehicle.`
            );

            // //logaction(
            //     `onSubmit(): Vehicle capacity exceeded - Used ${rawUsedPercentage.toFixed(2)}`,
            //     true
            // );
            setIsSubmitting(false);
            return;
        }

        for (const item of tableData) {
            if (item.shipQty === '' || item.shipQty === null) {
                logaction(`onSubmit(): Ship quantity empty for product ${item.SHPD_ProductCode}`, true);
                showToast('error', `Please Enter Ship Quantity for Product : ${item.SHPD_ProductName}.`);
                //logaction(`onSubmit(): Ship quantity is empty for product '${item.SHPD_ProductName}' (Product Code: ${item.SHPD_ProductCode})`, true);
                isValid = false;
            } else if (parseInt(item.shipQty) <= 0) {
                logaction(`onSubmit(): Invalid ship quantity for product ${item.SHPD_ProductCode}`, true);
                showToast('error', `Please Enter Ship Quantity for Product : ${item.SHPD_ProductName}.`);
                //logaction(`onSubmit(): Invalid ship quantity for product '${item.SHPD_ProductName}' (Product Code: ${item.SHPD_ProductCode})`, true);
                isValid = false;
            }
        }

        if (!isValid) {
            logaction("onSubmit(): Validation failed after shipQty check", true);
            return;
        }
        if (usedVolume > vehicleCapacity) {
            logaction(`onSubmit(): Vehicle capacity exceeded (final check) - Used ${rawUsedPercentage.toFixed(2)}%`, true);
            showToast('error',
                `Vehicle capacity exceeded with ${rawUsedPercentage.toFixed(2)}% of its capacity. Please reduce shipment quantity or select a larger vehicle.`
            );

            // //logaction(
            //     `onSubmit(): Vehicle capacity exceeded - Used ${rawUsedPercentage.toFixed(2)}`,
            //     true
            // );

            setIsSubmitting(false);
            return;
        }

        data.UM_CompanyID = parseInt(UM_CompanyID);
        data.UM_CompanyGrpID = parseInt(UM_CompanyGrpID);
        data.UM_UserId = parseInt(UM_UserId);
        data.selectedScpId = parseInt(selectedScpId);

        const fetchProductId = async (productName) => {
            logaction(`fetchProductId(): Started for ${productName}`);
            //logaction(`fetchProductId(): Started for ${productName}`);
            try {
                const response = await fetchWithRetry(`${config.API_URL}/api/product`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ productName }),
                });
                const responseData = await response.json();
                logaction(`fetchProductId(): Got ID ${responseData.productId}`);
                //logaction(`fetchProductId(): Got ID ${responseData.productId}`);
                setIsSubmitting(false);
                return responseData.productId || null;
            } catch (error) {
                logaction(`fetchProductId(): Error for ${productName}`, true);
                //logaction(`fetchProductId(): Error for ${productName}`, true);
                setIsSubmitting(false);
                return null;
            }
        };

        const formattedTableData = await Promise.all(
            tableData.map(async (item) => {
                let productId = item.productId;

                if (!productId) {
                    productId = await fetchProductId(item.SHPD_ProductName);
                }

                return {
                    orderNumber: item.ORDM_OrderNumber,
                    scpId: item.scpId,
                    productId, // ✅ REQUIRED FOR FEFO
                    productCode: item.SHPD_ProductCode,
                    productName: item.SHPD_ProductName,
                    orderedQty: parseInt(item.orderedQty),
                    shipQty: parseInt(item.shipQty),
                    pendingQty: parseInt(item.ORDIT_PendingQty),
                    originalPendingQty: parseInt(item.ORDIT_PendingQty)
                };
            })
        );

        const formattedData = {
            shipmentDate: format(selectedDate, 'dd/MM/yyyy'),
            returnReason: comment,
            logisticParty: logisticParty?.value || '',
            vehicleNumber: vehicleNumber?.value || '',
            routingLocation: routingLocation?.value || '',
            scanningMode: selectedStatus,
            tableData: formattedTableData,
            UM_CompanyID: data.UM_CompanyID,
            UM_CompanyGrpID: data.UM_CompanyGrpID,
            UM_UserId: data.UM_UserId,
            selectedOrderId: selectedOrder?.value || '',
            shipmentCode: shipmentCode,
            selectedScpId: data.selectedScpId,
            driverName,
            driverContact
        };

        logaction(`onSubmit(): Formatted Data prepared`);

        const initialShipQtySums = calculateShipQtySums(initialTableData);
        const finalShipQtySums = calculateShipQtySums(tableData);
        const shipQtyDifferences = {};
        const allProductCodes = new Set([...Object.keys(initialShipQtySums), ...Object.keys(finalShipQtySums)]);

        allProductCodes.forEach(productCode => {
            const initialQty = initialShipQtySums[productCode] || 0;
            const finalQty = finalShipQtySums[productCode] || 0;
            shipQtyDifferences[productCode] = finalQty - initialQty;
        });

        const transactionDetails = [
            {
                AUTRN_ParamererName: "Shipment Code",
                AUTRN_OldValue: shipmentCode,
                AUTRN_NewValue: shipmentCode
            },
            {
                AUTRN_ParamererName: "Shipment Type",
                AUTRN_OldValue: initialShipmentDetails.SHPH_ShipmentType || "-",
                AUTRN_NewValue: selectedShipmentType || "-"
            },
            {
                AUTRN_ParamererName: "Shipment Date",
                AUTRN_OldValue: initialShipmentDetails.SHPH_ShipmentDate || "-",
                AUTRN_NewValue: format(selectedDate, 'dd/MM/yyyy')
            },
            {
                AUTRN_ParamererName: "Scanning Mode",
                AUTRN_OldValue: scanningModeOptions.find(opt => opt.id === String(initialShipmentDetails.SHPH_ByProductVendorScanMode))?.label || "-",
                AUTRN_NewValue: scanningModeOptions.find(opt => opt.id === selectedStatus)?.label || "-"
            },
            {
                AUTRN_ParamererName: "Logistic Party Name",
                AUTRN_OldValue: logisticPartyOptions.find(opt => opt.value === initialShipmentDetails.SHPH_LogisticPartyID)?.label || "-",
                AUTRN_NewValue: logisticParty?.label || "-"
            },
            {
                AUTRN_ParamererName: "Vehicle Number",
                AUTRN_OldValue: vehicleNumbers.find(v => v.value === initialShipmentDetails.SHPH_LogisticVehicleID)?.label || "-",
                AUTRN_NewValue: vehicleNumber?.label || "-"
            },
            {
                AUTRN_ParamererName: "Route for Shipment Location",
                AUTRN_OldValue: routingNames.find(r => r.value === initialShipmentDetails.SHPH_SCPRouteID)?.label || "-",
                AUTRN_NewValue: routingLocation?.label || "-"
            },
            {
                AUTRN_ParamererName: "SCP Name",
                AUTRN_OldValue: scpNames.find(s => s.value === (initialShipmentDetails.SHPH_SCPID || selectedScpIdForOrder?.value))?.label || "-",
                AUTRN_NewValue: selectedScpIdForOrder?.label || "-"
            },
            {
                AUTRN_ParamererName: "Order Number",
                AUTRN_OldValue: initialTableData.map(row => row.ORDM_OrderNumber).join(', ') || "-",
                AUTRN_NewValue: tableData.map(row => row.ORDM_OrderNumber).join(', ') || "-"
            },
            {
                AUTRN_ParamererName: "Comment",
                AUTRN_OldValue: initialShipmentDetails.SHPH_Comment || "-",
                AUTRN_NewValue: comment || "-"
            },
            {
                AUTRN_ParamererName: "Shipment Status",
                AUTRN_OldValue: initialShipmentDetails.StatusDescription || "-",
                AUTRN_NewValue: enumtype || "-"
            },
            {
                AUTRN_ParamererName: "Shipment Details",
                AUTRN_OldValue: JSON.stringify(initialTableData.map(row => ({
                    "SCP Name": row.SCPM_Name,
                    "Order Number": row.ORDM_OrderNumber,
                    "Product Name": row.SHPD_ProductName,
                    "Product Code": row.SHPD_ProductCode,
                    "Available Quantity": row.AvailableQty,
                    "Order Quantity": row.orderedQty,
                    "Pending Quantity": row.ORDIT_PendingQty,
                    "Ship Quantity": row.shipQty
                }))),
                AUTRN_NewValue: JSON.stringify(tableData.map(row => ({
                    "SCP Name": row.SCPM_Name,
                    "Order Number": row.ORDM_OrderNumber,
                    "Product Name": row.SHPD_ProductName,
                    "Product Code": row.SHPD_ProductCode,
                    "Available Quantity": row.AvailableQty,
                    "Order Quantity": row.orderedQty,
                    "Pending Quantity": row.ORDIT_PendingQty,
                    "Ship Quantity": row.shipQty
                })))
            }
        ];

        try {
            logaction(`onSubmit(): Updating shipment ${shipmentCode}`);
            console.log(`Updating shipment with code: ${shipmentCode}`);

            const response = await fetchWithRetry(`${config.API_URL}/api/shipment/update/${shipmentCode}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formattedData),
            });

            const responseData = await response.json();
            logaction(`onSubmit(): Shipment updated successfully`);
            console.log('Shipment update response:', responseData);

            setLogisticPartyEmpty(false);
            setVehicleNumberEmpty(false);

            await logAudit(
                "Shipment Outward Edit",
                `Shipment: ${shipmentCode} updated successfully`,
                JSON.stringify(initialShipmentDetails),
                JSON.stringify(formattedData),
                transactionDetails
            );

            setIsLoading(true);

            toast.success(`Shipment : ${shipmentCode} updated successfully.`, {
                onClose: () => {
                    handleReset();
                    setIsSubmitting(false);
                    navigate(`/dashboard/shipment`);
                    setIsLoading(false);
                    setTableData([]);
                    sessionStorage.removeItem('selectedLogisticParty');
                    sessionStorage.removeItem('selectedRouting');
                    sessionStorage.removeItem('selectedScpName');
                    sessionStorage.removeItem('selectedOrder');
                    sessionStorage.removeItem('selectedVehicleNumber');
                    sessionStorage.removeItem('tableData');
                    sessionStorage.removeItem('selectedDate');
                    sessionStorage.removeItem('selectedStatus');
                    sessionStorage.removeItem('comment');
                    setSelectedScpIdForOrder('');
                    setSelectedScpNameForOrder('');
                    setComment('');
                },
            });

            try {
                logaction(`onSubmit(): Saving notification`);
                console.log(`Saving notification for shipment code: ${shipmentCode}`);

                const notificationResponse = await fetchWithRetry(`${config.API_URL}/notificationmaster/save`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        NFM_EventType: 'Shipment Edit',
                        NFM_EventBy: UM_UserId,
                        NFM_Status: 0,
                        NFM_EventMessage: `Shipment with Shipment code: '${shipmentCode}' updated successfully`,
                        NFM_CompanyID: UM_CompanyID,
                        NFM_CompanyGrpID: UM_CompanyGrpID,
                        NFM_SCPID: selectedScpId
                    }),
                });

                logaction(`onSubmit(): Notification saved successfully`);
            } catch (notificationError) {
                logaction(`onSubmit(): Notification save error`, true);
                console.error('Error saving notification:', notificationError);
                showToast('error', 'Some problem occurred while saving the notification.');
            }

            for (const [productCode, blockQty] of Object.entries(shipQtyDifferences)) {
                logaction(`Updating block quantity for product ${productCode} by ${blockQty}`);
                console.log(`Updating block quantity for product code: ${productCode}, blockQty: ${blockQty}`);

                const updateBlockQtyResponse = await fetchWithRetry(`${config.API_URL}/inventory/updateBlockQty`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ blockQty, scpid: selectedScpId, productCode }),
                });

                console.log(`Block quantity updated for product code: ${productCode}`);
            }

            const missingRecords = initialTableData.filter(initialItem =>
                !tableData.some(tableItem =>
                    tableItem.ORDM_OrderNumber === initialItem.ORDM_OrderNumber &&
                    tableItem.SHPD_ProductCode === initialItem.SHPD_ProductCode
                )
            );

            for (const row of [...tableData, ...missingRecords]) {
                const { SHPD_ProductName: productName, shipQty, orderedQty, ORDIT_PendingQty: pendingQty, ORDM_OrderNumber: orderNumber } = row;

                const productId = await fetchProductId(productName);

                if (productId === null) {
                    logaction(`onSubmit(): Product ID not found for ${productName}`, true);
                    console.error('Product ID not found for:', productName);
                    continue;
                }

                let updatedPendingQty = pendingQty;

                if (missingRecords.includes(row)) {
                    updatedPendingQty += shipQty;
                }

                logaction(`Updating pending quantity for order ${orderNumber}`);
                console.log(`Updating pending quantity for order: ${orderNumber}, product ID: ${productId}`);

                const shipQtyResponse = await fetchWithRetry(`${config.API_URL}/api/ordermaster/updatePendingQty`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ shipQty, productId, orderedQty, pendingQty: updatedPendingQty, orderNumber }),
                });

                console.log(`Pending quantity updated for order: ${orderNumber}`);
            }

            logaction("onSubmit(): Completed successfully");

        } catch (error) {
            logaction("onSubmit(): Error updating shipment", true);
            console.error('Error updating shipment:', error);
            showToast('error', `Failed to update shipment: ${error.message}`);
        }
    };


    const handleReset = () => {
        //logaction("handleReset(): Started");

        reset();

        // Existing resets
        setTableData([]);
        setLogisticParty(null);
        setVehicleNumber(null);
        setRoutingLocation(null);
        setSelectedOrder(null);
        setSelectedScpIdForOrder(null);
        setSelectedScpNameForOrder(null);
        setComment('');
        setOrdernoempty(false);
        setScpnameempty(false);
        setRoutenameempty(false);
        setVehicleNumberEmpty(false);
        setLogisticPartyEmpty(false);
        //setSelectedStatus('');

        setDriverName('');
        setDriverContact('');
        setPendingDriverName('');
        setPendingDriverContact('');
        setDriverErrors({
            name: false,
            contact: false,
        });


        //logaction("handleReset(): Form reset and table data restored to initial state");

        console.log('After handleReset - initialTableData:', initialTableData);
        console.log('After handleReset - tableData:', JSON.parse(JSON.stringify(initialTableData)));
    };


    const handleScpNameChange = (selectedOption) => {
        //logaction(`handleScpNameChange(): Started with selected value: ${selectedOption?.value}`);
        setSelectedOrder(null);
        setScpnameempty(false);
        setOrderNumbers([]);
        setSelectedScpIdForOrder(selectedOption);
        setSelectedScpNameForOrder(selectedOption);
        //logaction(`handleScpNameChange(): Selected SCP ID: ${selectedOption?.value}, Selected SCP Name: ${selectedOption?.label}`);
    };

    const handleOrderSelect = (selectedOption) => {
        //logaction(`handleOrderSelect(): Started with selected order number: ${selectedOption?.value}`);

        setOrdernoempty(false);
        setSelectedOrder(selectedOption);
        //logaction(`handleOrderSelect(): Selected order number set to: ${selectedOption?.value}`);
    };

    const isRoutingLocationDisabled = () => {
        //logaction(`isRoutingLocationDisabled(): Checking if routing location should be disabled. Table data length: ${tableData.length}`);
        return tableData.length > 0;
    };

    const handleStatuschange = (e) => {
        const selectedStatus = e.target.value;
        //logaction(`handleStatuschange(): Started with selected status: ${selectedStatus}`);
        setSelectedStatus(selectedStatus);
        //logaction(`handleStatuschange(): Selected status set to: ${selectedStatus}`);
    };

    const handleInputChange = (index, sanitizedValue) => {
        const value = sanitizedValue;
        if (/^\d*$/.test(value)) {
            const newTableData = JSON.parse(JSON.stringify(tableData));
            const newShipQty = parseInt(value, 10) || 0;
            const originalShipQty = newTableData[index].originalShipQty || 0;
            const originalAvailableQty = newTableData[index].originalAvailableQty || 0;
            const originalPendingQty = newTableData[index].originalPendingQty || 0;
            const difference = newShipQty - originalShipQty;
            const pending = originalPendingQty + originalShipQty;
            const available = originalAvailableQty + originalShipQty;

            if (newShipQty > pending) {
                showToast('error', `Ship Quantity cannot exceed the total pending quantity of ${pending}.`);
                return;
            }

            if (newShipQty > available) {
                showToast('error', `Ship Quantity cannot exceed the available quantity of ${available}.`);
                return;
            }

            newTableData.forEach((row, i) => {
                if (row.SHPD_ProductCode === newTableData[index].SHPD_ProductCode) {
                    if (i === index) {
                        row.ORDIT_PendingQty = originalPendingQty - difference;
                    }
                    row.AvailableQty = originalAvailableQty - difference;
                }
            });

            newTableData[index].shipQty = newShipQty;
            setTableData(newTableData);
            console.log('After handleInputChange - initialTableData:', initialTableData);
            console.log('After handleInputChange - tableData:', newTableData);
        }
    };

    const handleCommentChange = (event) => {
        const newComment = event.target.value;
        setComment(newComment);
        //logaction(`handleCommentChange() : Comment changed::: ${newComment}`);
    };

    const handleDateChange = (date) => {
        console.log("handleDateChange(): Started");
        setModalSelectedDate(date);
        setShowModal(true);
        console.log(`handleDateChange(): Date changed to ${date ? format(date, 'dd/MM/yyyy') : 'null'}`);
        console.log("handleDateChange(): Ended");
    };

    const handleModalCancel = () => {
        setShowModal(false);
        console.log("handleModalCancel(): Date Modal Closed");
    };

    const handleModalConfirm = () => {
        setSelectedDate(modalSelectedDate);
        console.log("handleModalConfirm() : Confirm Modal for date change is opened");
        sessionStorage.setItem('selectedDate', modalSelectedDate ? format(modalSelectedDate, 'dd/MM/yyyy') : '');
        setShowModal(false);
    };

    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };

    const handleCloseModal = () => {
        setPendingDriverName(driverName);
        setPendingDriverContact(driverContact);

        setDriverErrors({
            name: false,
            contact: false,
        });

        setShowDriverModal(false);
    };

    const hasVehicleCapacity = Number(vehicleNumber?.dimension) > 0;

    const hasProductVolume = tableData.some(row =>
        Number(row.shipQty) > 0 && Number(row.volume) > 0
    );

    const canCalculateCapacity = hasVehicleCapacity && hasProductVolume;

    const usedVolume = canCalculateCapacity
        ? tableData.reduce((sum, row) => {
            const qty = Number(row.shipQty) || 0;
            const volume = Number(row.volume) || 0;
            return sum + qty * volume;
        }, 0)
        : 0;

    const vehicleCapacity = canCalculateCapacity
        ? Number(vehicleNumber?.dimension) || 0
        : 0;

    const rawUsedPercentage = canCalculateCapacity && vehicleCapacity
        ? Math.round(((usedVolume / vehicleCapacity) * 100 + Number.EPSILON) * 100) / 100
        : 0;

    const barPercentage = Math.min(rawUsedPercentage, 100);

    const remainingVolume = canCalculateCapacity
        ? Math.max(vehicleCapacity - usedVolume, 0)
        : 0;



    const handleEditVehicleNumberChange = (selectedOption) => {
        if (!selectedOption) return;

        // ✅ Apply vehicle immediately
        setVehicleNumber(selectedOption);

        //logaction(`Vehicle applied: ${selectedOption.label}`);
        //logaction(`Dimension applied: ${selectedOption.dimension}`);

        // ✅ Open modal optionally
        setShowDriverModal(true);
    };


    return (
        <>
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />

            {isLoading && (
                <div
                    style={{
                        position: 'fixed',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 1000,
                    }}
                />
            )}
            {isSubmitting && (
                <div style={{
                    position: 'fixed', // Sit on top of the page content
                    left: 0,
                    top: 0,
                    width: '100%', // Full width
                    height: '100%', // Full height
                    zIndex: 1000 // Sit on top of the other elements
                }} />
            )}
            <form onSubmit={handleSubmit(onSubmit)}>
                {canCalculateCapacity && (
                    <div className="vehicle-capacity-fixed">
                        <div className="vehicle-capacity-inline">

                            {/* ===== SUMMARY + HOVER ===== */}
                            <div className="capacity-summary-compact">
                                <strong>{rawUsedPercentage.toFixed(2)}%</strong> Used

                                <span className="ms-2 capacity-info-icon" tabIndex={0}>
                                    <AiOutlineInfoCircle />
                                    <div className="capacity-tooltip">
                                        <div>
                                            <strong>Vehicle Capacity : </strong> {vehicleCapacity}
                                        </div>
                                        <div>
                                            <strong>Used : </strong> {usedVolume.toFixed(2)}
                                        </div>
                                        <div>
                                            <strong>Remaining : </strong> {remainingVolume.toFixed(2)}
                                        </div>
                                    </div>
                                </span>
                            </div>

                            {/* ===== CAPACITY BAR ===== */}
                            <div className="capacity-bar-inline">
                                <div className="capacity-bar-bg">
                                    <div
                                        className={`capacity-bar-fill ${rawUsedPercentage > 100
                                            ? 'over'
                                            : rawUsedPercentage > 80
                                                ? 'warning'
                                                : 'normal'
                                            }`}
                                        style={{ width: `${barPercentage}%` }}
                                    />
                                </div>
                            </div>

                            {/* ===== OVERLOAD WARNING ===== */}
                            {rawUsedPercentage > 100 && (
                                <div className="overload-alert-inline">
                                    ⚠ Capacity Exceeded
                                </div>
                            )}

                        </div>
                    </div>
                )}


                <div className='main_container' style={{ paddingTop: canCalculateCapacity ? '30px' : '12px' }}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="page-header">
                                <h2 className="formHeading">Shipment Master</h2>
                            </div>
                            <div className="row mb-">
                                <div className="col-md-4 mt-1">
                                    <label className="form-label">Shipment Type </label>
                                    <div className='select-container'>
                                        <select {...register('shipmentType')}
                                            disabled
                                            className="select-box"
                                            value={selectedShipmentType}
                                            style={{ backgroundColor: '#f2f2f2', color: '#6c757d' }}>
                                            <option value="New Order">New Order</option>
                                            <option value="Return">Return</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-1">
                                    <label className="form-label">Shipment Date </label>
                                    <div className='select-container'>
                                        <DatePicker
                                            selected={selectedDate}
                                            onChange={handleDateChange}
                                            dateFormat="dd/MM/yyyy"
                                            onKeyDown={(e) => e.preventDefault()}
                                            disabled
                                            style={{
                                                backgroundColor: '#f2f2f2',
                                                color: '#6c757d',
                                            }}
                                            className="select-box"
                                        />
                                    </div>
                                </div>
                                {showModal && (
                                    <div className="popup_overlay">
                                        <div className="resetpopup">
                                            <h1>:: User Confirmation ::</h1>
                                            <h4>Are you sure you want to change the date ?</h4>
                                            <div className="popup_btn_container">
                                                <button className="yes_btn " onClick={handleModalConfirm}>
                                                    YES
                                                </button>
                                                <button className="no_btn " onClick={handleModalCancel}>
                                                    NO
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="col-md-4 mt-1">
                                    <label className="form-label">Shipment Status </label>
                                    <input
                                        type="text"
                                        value={enumtype}
                                        disabled
                                        style={{ backgroundColor: '#f2f2f2', color: '#6c757d' }}
                                        className='form-input'
                                    />
                                </div>
                                <div className="col-md-4 row mt-2">
                                    <div className="col-md-11">
                                        <label className="form-label">Logistic Party Name {logisticPartyEmpty && <span className="text-danger"> *</span>}</label>
                                        <div className='select-container'>
                                            <Select
                                                {...register('logisticParty')}
                                                options={logisticPartyOptions}
                                                value={logisticParty}
                                                onChange={handleLogisticPartyChange}
                                                placeholder="--Select--"
                                                className="routing_select-box"
                                                classNamePrefix="react-select"
                                                components={{ SingleValue: CustomSingleValue }}
                                                isDisabled={isLoading}
                                                onMenuOpen={() => handleSelectOpen('Logistic')}
                                                onMenuClose={handleSelectClose}
                                                maxMenuHeight={"120px"}
                                            />
                                            <div className='icon-container_list myList'>
                                                <i>
                                                    {isSelectOpen === 'Logistic' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <Link to={`/dashboard/lgcm`}>
                                            <img src={add} alt="Add All Icon"
                                                title='Create Vehicle'
                                                style={{
                                                    width: '19px',
                                                    height: '19px',
                                                    marginTop: '41px',
                                                    filter: 'brightness(0.4)'
                                                    // marginLeft: '-10px'
                                                }} />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-4 row mt-2" style={{ marginLeft: '13px' }}>
                                    <div className="col-md-11">
                                        <label className="form-label">Vehicle Number {vehicleNumberEmpty && <span className="text-danger"> *</span>}</label>
                                        <div className='select-container'>
                                            <Select
                                                options={vehicleNumbers}
                                                value={vehicleNumber}              // ✅ DIRECT object
                                                onChange={handleEditVehicleNumberChange}
                                                placeholder="--Select--"
                                                className="routing_select-box"
                                                classNamePrefix="react-select"
                                                components={{ SingleValue: CustomSingleValue }}
                                                onMenuOpen={() => handleSelectOpen('Vehicle')}
                                                onMenuClose={handleSelectClose}
                                                isDisabled={isLoading}
                                                maxMenuHeight="120px"
                                            />


                                            <div className='icon-container_list myList'>
                                                <i>
                                                    {isSelectOpen === 'Vehicle' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1 d-flex align-items-end justify-content-center">
                                        <div
                                            className={`driver-icon-btn ${!vehicleNumber ? 'disabled' : ''}`}
                                            onClick={() => {
                                                if (!vehicleNumber) return;
                                                setShowDriverModal(true);
                                            }}
                                            title="Add Driver Details"
                                        >
                                            <BsPersonBadge size={26} />
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-4 mt-2" style={{ marginLeft: '21px' }}>
                                    <label className="form-label">
                                        Scanning Mode {scanningModeEmpty && <span className="text-danger"> *</span>}
                                    </label>

                                    {isScanningModeDisabled ? (
                                        <input
                                            type="text"
                                            value={
                                                scanningModeOptions.find(opt => opt.id === selectedStatus)?.label || ""
                                            }
                                            disabled
                                            style={{
                                                backgroundColor: "#f2f2f2",
                                                color: "#6c757d",
                                                width: "100%",
                                                padding: "0.375rem 0.75rem",
                                                border: "1px solid #ced4da",
                                                borderRadius: "0.25rem",
                                                fontSize: "1rem",
                                                lineHeight: "1.5"
                                            }}
                                        />
                                    ) : (
                                        <div className="select-container">
                                            <Select
                                                className="routing_select-box"
                                                classNamePrefix="react-select"
                                                components={{ SingleValue: CustomSingleValue }}
                                                options={scanningModeOptions}
                                                value={
                                                    scanningModeOptions.find(opt => opt.id === selectedStatus) || null
                                                }
                                                onChange={(option) => {
                                                    const selectedValue = option ? option.id : '';
                                                    handleStatuschange({ target: { value: selectedValue } });
                                                }}
                                                placeholder="--Select--"
                                                onMenuOpen={() => handleSelectOpen('scanningMode')}
                                                onMenuClose={handleSelectClose}
                                                maxMenuHeight={140}
                                                isSearchable={false}
                                            />

                                            <div className="icon-container_list myList">
                                                <i>
                                                    {isSelectOpen === 'scanningMode' ? (
                                                        <IoCaretUpOutline />
                                                    ) : (
                                                        <IoCaretDownOutline />
                                                    )}
                                                </i>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-4 row mt-2">
                                    <div className="col-md-11">
                                        <label className="form-label">Route for Shipment Location {routenameempty && <span className="text-danger"> *</span>}</label>
                                        <div className='select-container'>
                                            <Select
                                                {...register('routingLocation')}
                                                options={routingNames}
                                                value={routingLocation}
                                                onChange={handleRoutingChange}
                                                placeholder="--Select--"
                                                className="routing_select-box"
                                                classNamePrefix="react-select"
                                                components={{ SingleValue: CustomSingleValue }}
                                                isDisabled={isLoading || isRoutingLocationDisabled()}
                                                onMenuOpen={() => handleSelectOpen('Route')}
                                                onMenuClose={handleSelectClose}
                                                maxMenuHeight={"120px"}
                                            />
                                            <div className='icon-container_list myList'>
                                                <i>
                                                    {isSelectOpen === 'Route' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <Link to={`/dashboard/rm`}>
                                            <img src={add} alt="Add All Icon" style={{
                                                width: '19px',
                                                height: '19px',
                                                filter: 'brightness(0.4)',
                                                marginTop: '41px',
                                            }} />
                                        </Link>
                                    </div>
                                </div>
                                <div className="ms-4 col-md-4 mt-2">
                                    <label className="form-label">SCP Name {scpnameempty && <span className="text-danger"> *</span>}</label>
                                    <div className='select-container'>
                                        <Select
                                            options={scpNames}
                                            value={selectedScpIdForOrder}
                                            onChange={handleScpNameChange}
                                            placeholder="--Select--"
                                            className="routing_select-box"
                                                classNamePrefix="react-select"
                                                components={{ SingleValue: CustomSingleValue }}
                                            isDisabled={isLoading}
                                            onMenuOpen={() => handleSelectOpen('SCP')}
                                            onMenuClose={handleSelectClose}
                                            maxMenuHeight={"120px"}
                                        />
                                        <div className='icon-container_list myList'>
                                            <i>
                                                {isSelectOpen === 'SCP' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                            </i>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 row mt-2">
                                    <div className="col-md-11">
                                        <label className="form-label">Order Number {ordernoempty && <span className="text-danger"> *</span>}</label>
                                        <div className='select-container'>
                                            <Select
                                                {...register('selectedOrderId')}
                                                options={orderNumbers}
                                                value={selectedOrder}
                                                onChange={handleOrderSelect}
                                                placeholder="--Select--"
                                                className="routing_select-box"
                                                classNamePrefix="react-select"
                                                components={{ SingleValue: CustomSingleValue }}
                                                isDisabled={isLoading}
                                                onMenuOpen={() => handleSelectOpen('Order')}
                                                onMenuClose={handleSelectClose}
                                                maxMenuHeight={"120px"}
                                            />
                                            <div className='icon-container_list myList'>
                                                <i>
                                                    {isSelectOpen === 'Order' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <MdPlaylistAdd
                                            onClick={handleAddAllButtonClick}
                                            title="Add All"
                                            style={{
                                                fontSize: "28px",
                                                marginTop: "38px",  // adjust for visual alignment
                                                cursor: "pointer"
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='commentContainer mt-2'>
                                    <div className="col-md-4">
                                        <label htmlFor="returnComment">Add Comment </label>
                                        <textarea
                                            id="returnComment"
                                            name="returnComment"
                                            value={comment}
                                            onChange={handleCommentChange}
                                            rows="3"
                                            style={{
                                                border: '1px solid #ced4da',
                                                padding: '10px',
                                                width: '100%',
                                                fontSize: '16px',
                                                resize: 'none',
                                                overflow: 'auto',
                                                transition: 'height 0.3s',
                                                borderRadius: "5px",
                                                outline: "none"
                                            }}
                                            placeholder="Enter your comment..."
                                        />
                                    </div>
                                    <div className="mb-4 text-center col-md-8">
                                        <button type="button" onClick={handleAddButtonClick} className="shipment_add_btn me-2">ADD</button>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive mb-3">
                                {tableData.length > 0 && (
                                    <table className="tableClass">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>SCP Name</th>
                                                <th>Order Number</th>
                                                <th>Product Name</th>
                                                <th>Product Code</th>
                                                <th>Available Quantity</th>
                                                <th>Order Quantity</th>
                                                <th>Pending Quantity</th>
                                                <th>Volume</th>
                                                <th>Ship Quantity</th>

                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableData.map((row, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td style={{ display: 'none' }}>{row.scpId}</td>
                                                    <td>{row.SCPM_Name}</td>
                                                    <td>{row.ORDM_OrderNumber}</td>
                                                    <td>{row.SHPD_ProductName}</td>
                                                    <td>{row.SHPD_ProductCode}</td>
                                                    <td>{row.AvailableQty}</td>
                                                    <td>{row.orderedQty}</td>
                                                    <td>{row.ORDIT_PendingQty}</td>
                                                    <td>{row.volume}</td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            inputMode="numeric"
                                                            pattern="[0-9]*"
                                                            name={`shipQty${index}`}
                                                            value={row.shipQty === 0 ? '' : row.shipQty}
                                                            onChange={(e) => {
                                                                const rawValue = e.target.value;
                                                                const sanitizedValue = rawValue.replace(/^0+(?!$)/, '');

                                                                if (sanitizedValue === '' || /^\d+$/.test(sanitizedValue)) {
                                                                    handleInputChange(index, sanitizedValue);
                                                                }
                                                            }}
                                                        />
                                                    </td>

                                                    <td>
                                                        <img
                                                            src={Icon5}
                                                            onClick={() => showConfirmDialog(index)}
                                                            className="suspendicon"
                                                            alt="suspend"
                                                            title='Remove'
                                                            style={{ marginLeft: '8px' }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                                {showConfirmation && (
                                    <div className="popup_overlay">
                                        <div className="resetpopup">
                                            <h1>:: User Confirmation ::</h1>
                                            <h4>Are you sure you want to remove this row ?</h4>
                                            <div className="popup_btn_container">
                                                <button className="yes_btn " onClick={handleConfirmedRemoval}>
                                                    YES
                                                </button>
                                                <button className="no_btn " onClick={hideConfirmDialog}>
                                                    NO
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <Modal
                                    show={showDriverModal}
                                    backdrop="static"
                                    onHide={handleCloseModal}
                                    keyboard={false}
                                    centered
                                    style={{
                                        backdropFilter: 'blur(3px)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                    }}
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title style={{ fontSize: '20px', fontWeight: 'bold' }}>
                                            Driver Details
                                        </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body>
                                        <div className="emailModal">

                                            {/* ---------- NAME ---------- */}
                                            <label>
                                                Driver Name
                                                {driverErrors.name && <span className="text-danger"> *</span>}
                                            </label>

                                            <input
                                                className="esett"
                                                type="text"
                                                maxLength={100}
                                                value={pendingDriverName}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^a-zA-Z ]/g, '');
                                                    setPendingDriverName(value);

                                                    // ✅ Clear only if valid
                                                    if (value.trim() && driverErrors.name) {
                                                        setDriverErrors(prev => ({ ...prev, name: false }));
                                                    }
                                                }}
                                            />

                                            {/* ---------- PHONE ---------- */}
                                            <label style={{ width: '100%' }}>
                                                Driver Phone Number
                                                {driverErrors.contact &&
                                                    <span className="text-danger">{driverErrors.message}</span>}
                                            </label>

                                            <PhoneInput
                                                className="phone-input-custom"
                                                dropdownClass="phone-dropdown-scroll"
                                                key={phoneNumberCountry + '-' + resetCounter}
                                                country={phoneNumberToCountryCode(phoneNumberCountry) || 'in'}
                                                value={pendingDriverContact}
                                                onlyCountries={allowedCountries}
                                                countryCodeEditable={false}
                                                inputClass="esett"
                                                autoComplete="off"

                                                onChange={(value, countryData) => {
                                                    const newDialCode = countryData?.dialCode || '91';
                                                    const maxLength = phoneLengthMapping[newDialCode] || 10;

                                                    let digits = value.replace(/\D/g, "");

                                                    if (digits.startsWith(newDialCode)) {
                                                        digits = digits.slice(newDialCode.length);
                                                    }

                                                    let local = digits.slice(0, maxLength);
                                                    const finalValue = newDialCode + local;

                                                    setPendingDriverContact(finalValue);

                                                    /* ✅ Check validity */
                                                    let isValid = true;

                                                    if (!local.length) isValid = false;
                                                    else if (local.startsWith("0")) isValid = false;
                                                    else if (local.length < maxLength) isValid = false;

                                                    /* ✅ Clear only when valid */
                                                    if (isValid && driverErrors.contact) {
                                                        setDriverErrors(prev => ({
                                                            ...prev,
                                                            contact: false,
                                                            message: ""
                                                        }));
                                                    }

                                                    prevCountryRef.current = newDialCode;
                                                }}

                                                onCountryChange={(country) => {
                                                    setPhoneNumberCountry(country.dialCode);
                                                    setPendingDriverContact(country.dialCode);
                                                    prevCountryRef.current = country.dialCode;
                                                }}
                                            />

                                        </div>
                                    </Modal.Body>

                                    {/* ---------- OK BUTTON ---------- */}
                                    <Modal.Footer style={{ justifyContent: 'center' }}>
                                        <button
                                            className="add_btn"
                                            style={{
                                                fontWeight: 700,
                                                fontSize: "16px",
                                                letterSpacing: "0.5px"
                                            }}
                                            onClick={() => {
                                                let hasError = false;

                                                const dialCode = prevCountryRef.current || "91";
                                                const maxLength = phoneLengthMapping[dialCode] || 10;

                                                const digits = pendingDriverContact
                                                    ?.replace(/\D/g, "")
                                                    .slice(dialCode.length) || "";

                                                /* ---------- NAME VALIDATION ---------- */
                                                if (!pendingDriverName.trim()) {
                                                    hasError = true;
                                                    setDriverErrors(prev => ({
                                                        ...prev,
                                                        name: true
                                                    }));
                                                }

                                                /* ---------- PHONE VALIDATION ---------- */
                                                if (!digits) {
                                                    hasError = true;
                                                    setDriverErrors(prev => ({
                                                        ...prev,
                                                        contact: true,
                                                        message: " *"
                                                    }));
                                                }
                                                else if (digits.startsWith("0")) {
                                                    hasError = true;
                                                    setDriverErrors(prev => ({
                                                        ...prev,
                                                        contact: true,
                                                        message: " Driver Phone Number cannot start with 0"
                                                    }));
                                                }
                                                else if (digits.length < maxLength) {
                                                    hasError = true;
                                                    setDriverErrors(prev => ({
                                                        ...prev,
                                                        contact: true,
                                                        message: ` Driver Phone Number must be exactly ${maxLength} digits`
                                                    }));
                                                }

                                                if (hasError) return;

                                                /* ---------- APPLY ---------- */
                                                setDriverName(pendingDriverName);
                                                setDriverContact(pendingDriverContact);

                                                sessionStorage.setItem('driverName', pendingDriverName);
                                                sessionStorage.setItem('driverContact', pendingDriverContact);

                                                setShowDriverModal(false);
                                            }}
                                        >
                                            OK
                                        </button>
                                    </Modal.Footer>
                                </Modal>

                            </div>
                            {showconfimationModal && (
                                <div className="popup_overlay">
                                    <div className="resetpopup">
                                        <h1>:: User Confirmation ::</h1>
                                        <h4>Are you sure you want to update the Shipment : {shipmentCode} ?</h4>
                                        <div className="popup_btn_container">
                                            <button
                                                className="yes_btn"
                                                onClick={() => {
                                                    setshowconfimationModal(false);
                                                    handleSubmit(onSubmit)();
                                                }}
                                            >
                                                YES
                                            </button>

                                            <button
                                                className="no_btn"
                                                onClick={() => setshowconfimationModal(false)}
                                            >
                                                NO
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='button-container'>
                    <button
                        type="button"
                        onClick={handleSubmit(validateBeforeConfirm)}
                        className="save_btn"
                    >
                        SAVE
                    </button>
                    <button type="button" onClick={handleReset} className="reset_btn">RESET</button>
                    <Link to={`/shipmentlist`} className="list_btn" type="button">LIST</Link>
                </div>
            </form>
        </>
    );
};

export default ShipmentEdit;